module.exports = __webpack_public_path__ + "static/img/top-img-sm.6673766.png";